{
  "code": "आमंत्रण कोड",
  "error": {
    "details": "<ul>  \n<li>कृपया किसी भी टाइपो की जांच करें और फिर से प्रयास करें।</li>  \n<li>अगर आप अटक गए हैं, तो हमें इस नंबर पर कॉल करें: {{phone}} (फिर विकल्प 2 दबाएं)।</li>  \n</ul>",
    "title": "यह आमंत्रण कोड काम नहीं कर रहा है"
  },
  "helpMessage": "<p>आपका आमंत्रण खो गया है या आप नहीं जानते क्या करना है?<br />कृपया हमें <a><strong>{{phone}}</strong></a> पर कॉल करें (फिर <strong>विकल्प 2</strong> दबाएं)।</p>",
  "text": "<p>शुरू करने के लिए अपना 6-अक्षरों वाला आमंत्रण कोड दर्ज करें।</p><p>यह कोड आपको अपने ईमेल आमंत्रण में मिलेगा, या आपके रेफ़रर ने आपको यह कोड दिया हो सकता है।</p>",
  "title": "अपना बुकिंग आमंत्रण खोलें"
}
